import React from "react";
import { images  } from "../../constants";
import './Navbar.scss';
import {HiMenuAlt4, HiX} from 'react-icons/hi' ;
import {motion} from 'framer-motion'
import { useState } from "react";
import { BsTwitter, BsInstagram, BsLinkedin} from "react-icons/bs";

const navLinks = ['home', 'about', 'work', 'skills', 'contact' ]
const Navbar = () => {
    const [toggle, setToggle ] = useState(false);
    const [activeLink] = useState('')


    return(
        <nav className="app__navbar">
            <div className="app__navbar-logo">
                <img src={images.logo} alt='myLogo'/>
            </div>
                <ul className="app__navbar-links">
                    {navLinks.map((item) => (
                        <li key={`link-${item}`}
                        // onClick={() =>setActiveLink(item)}
                        className = {` app__flex p-text ${activeLink === item ? 'active' : ''}`}
                        >
                            <div />
                            <a href={`#${item}`}
                            >{item}</a>
                        </li>
                    ))}
                </ul>
                <div className="app__navbar-menu">
                        <HiMenuAlt4 onClick={()=> setToggle(true)}/>

                        {
                            toggle && (
                                <motion.div
                                 whileInView={{ x: [100, 0] }}
                                 transition={{ duration: 0.85, ease:'easeOut' }}
                                 >
                                    <HiX style={{color:"white"}} onClick={()=> setToggle(false)}/>
                                    <ul>
                                    {navLinks.map((item) => (
                                    <li key={{item}}>
                                        <a href={`#${item}`} onClick={()=> setToggle(false)} >{item}</a>
                                
                                    </li>
                                    ))}
                                    </ul>
                                    <div className='app__menu__social'>
                                            <div>
                                                <a href='https://instagram.com/Sbieey' target="_blank" without rel="noreferrer"><BsInstagram /></a>
                                            </div>
                                            <div>
                                            <a href= 'https://twitter.com/Sbiiey' target="_blank" without rel="noreferrer"><BsTwitter /></a>
                                            </div>
                                            <div>
                                            <a  href='https://www.linkedin.com/in/muhammad-kabiru-suleiman-2647531b5/' target="_blank" without rel="noreferrer"><BsLinkedin /></a>
                                            </div>
                                        </div>
                                 </motion.div>
                            )
                        }
                </div>
        </nav>
    )
}

export default Navbar;